const GAZA_DEPARTMENT = "GAZA_DEPARTMENT";
const QUDUS_DEPARTMENT = "QUDUS_DEPARTMENT";
const LOD_DEPARTMENT = "LOD_DEPARTMENT";
const HAIFA_DEPARTMENT = "HAIFA_DEPARTMENT";
const GALILEE_DEPARTMENT = "GALILEE_DEPARTMENT";
const SAMARIA_DEPARTMENT = "SAMARIA_DEPARTMENT";

export {
  GAZA_DEPARTMENT,
  QUDUS_DEPARTMENT,
  LOD_DEPARTMENT,
  HAIFA_DEPARTMENT,
  GALILEE_DEPARTMENT,
  SAMARIA_DEPARTMENT,
};
